import { Alert } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface RequiredInfoAlertProps {
    isDataValid: boolean;
}

export const RequiredInfoAlert: React.FC<RequiredInfoAlertProps> = ({ isDataValid }) => {
    const { t } = useTranslation();

    return isDataValid ? (
        <Alert severity='success' sx={{ my: 2 }}>
            {t('backgroundCheck.messages.requiredInfoProvided')}
        </Alert>
    ) : (
        <Alert severity='error' sx={{ my: 2 }}>
            {t('backgroundCheck.messages.requiredInfoMissing')}
        </Alert>
    );
};
